import { Component, OnInit } from '@angular/core';
import { MobileNavService } from '../../shared/services/mobile-nav.service';
import { AuthService } from '../../shared/services/auth/auth.service';
import { AssociateService } from '../../shared/services/associate.service';
import { Router } from '@angular/router'
import { TranslateService } from '@ngx-translate/core';
import { StaticValueService } from '../../shared/services/static-value.service'
import { Configuration } from '../../app.constants';
import * as io from 'socket.io-client';
import { SocketService } from 'app/shared/services/socket.service';

@Component({
    selector: 'app-mobile-nav',
    templateUrl: './mobile-nav.component.html',
    styleUrls: ['./mobile-nav.component.scss']
})
export class MobileNavComponent implements OnInit {
    SWIPE_ACTION = { LEFT: 'swipeleft', RIGHT: 'swiperight' };
    public navList: any;
    navbar: any;
    navLinks = [];
    public serverApiUrl;
    public associate: any;
    public imagePlaceholder: any;
    public archiveSocket: any;
    public user: any;
    public selectedTab = 'Timeline';
    public language = 'english'

    constructor(public mobileNav: MobileNavService, public authService: AuthService, public translateService: TranslateService,
        public activeRouter: Router, public associateService: AssociateService,
        public config: Configuration, public staticService: StaticValueService,
        private socketService:SocketService,
        ) {
        this.translateService.use(this.staticService.getLanguage())

        // this.archiveSocket = io(this.config.SocketUrl);
        this.translateService.onLangChange.subscribe(res => {
            console.log('mobile language ', res.lang)
            this.translateService.use(res.lang);
            console.log('current language ', this.translateService.currentLang)
        });

        this.translateService.setDefaultLang('english');
        this.language = this.translateService.currentLang ? this.translateService.currentLang : 'english';


        this.authService.displayImageUrlObs.subscribe((data) => {
            if (data) {
                this.associate.personalInformation.avatarUrl = data;
            }
        });

        this.navbar = { show: false };
    }

    ngOnInit() {
        this.serverApiUrl = this.config.StaticImageUrl;
        this.user = this.authService.user;
        this.selectedTab = this.activeRouter.url;
        this.activeRouter.events.subscribe((newroute) => {
            this.selectedTab = newroute['url'];
        });
        this.associateService.getAssociate(this.user.associateId).subscribe(associates => {
            this.associate = associates['data'][0];
            // this.socketListner();
            if (!this.associate['active'] && this.associate['_id'] === this.user.associateId) {
                this.onLogout();
            }

            if (this.associate.personalInformation.gender.includes('Male')) {
                this.imagePlaceholder = 'assets/img/Male-orange.png'
            } else if (this.associate.personalInformation.gender.includes('Female')) {
                this.imagePlaceholder = 'assets/img/Female-orange.png'
            }
        });
        this.navbar = this.mobileNav.getSideNav();

        this.navList = this.authService.user.clientAcl['navViews'];
        for (let key in this.navList) {
            if (key !== null) {
                let navOptions = {
                    key: key,
                    value: this.navList[key].label,
                    icon: this.navList[key].icon
                };
                this.navLinks.push(navOptions);
            }
        }

        // this.archiveSocket.on(`archive-${this.user.associateId}`, function (data) {
        //     if (data) {
        //         this.onLogout();
        //     }
        // }.bind(this));

    }

    socketListner(){
        this.socketService.archiveObs.subscribe(res=>{
            if (res) {
                this.onLogout();
            }
        });
    }

    drawerClose(event) {
        if (event.x > (0.65 * window.innerWidth)) {
            this.mobileNav.hideSideNav();
        }
    }
    onClick() {
        console.log('CLicked');
        this.mobileNav.hideSideNav();
    }

    swipe(action = this.SWIPE_ACTION.RIGHT) {
        if (action === this.SWIPE_ACTION.LEFT) {
            this.mobileNav.hideSideNav();
        }
    }
    mobileTabs(value) {
        if (value === 'Timeline' || value === 'Associate Directory' || value === 'Companies' || value === 'Workgroups' || value === 'Lists') {
            return false;
        } else {
            return true;
        }
    }
    onLogout() {
        this.authService.logout();
        this.mobileNav.hideSideNav();                      // {3}
    }
    click(value) {
        this.selectedTab = value;
    }

    languageChange(lang: string) {
        this.translateService.use(lang);
        this.language = lang;
        this.staticService.setLanguage(lang);
    }
}
